import { Link as RouterLink } from 'react-router-dom';
// material
import { Grid, Button, Container, Stack, Typography } from '@mui/material';
// components

import Iconify from 'src/components/Iconify';
import Page from 'src/components/Page';
// import AgentDataCard from 'src/sections/agentreports/AgentDataCard';
import { AgentReportCard } from 'src/sections/agentreports';
import useAgentFEC from 'src/api/Agentwise/useAgentFEC';
// ----------------------------------------------------------------------
const SORT_OPTIONS = [
  { value: 'latest', label: 'Latest' },
  { value: 'popular', label: 'Popular' },
  { value: 'oldest', label: 'Oldest' }
];

// ----------------------------------------------------------------------

export default function AgentwiseFEC() {


  const [reportData] = useAgentFEC()
  return (
    <Page title="Dashboard: Blog | Minimal-UI">
      <Container maxWidth="xxl">
        <Grid container spacing={3}>
            <AgentReportCard reportData={reportData}/>
        </Grid>
      </Container>
    </Page>
  );
}


